import { SizeType } from '@config/type'
import cn from 'classnames'

import { ReactComponent as LogoUser } from '../../assets/img/logo-user.svg'

import styles from './address-item-mobile.module.css'

type AddressSearchItemMobileProps = {
  className?: string
  address: string
  count: number
  onClick: () => void
  sizeType?: SizeType
  fontType?: SizeType
  styleType?: 'primary' | 'secondary' | 'inverse' | 'transparent' | 'danger'
}

export const AddressSearchItemMobile = ({
  className,
  address,
  count,
  onClick,
  sizeType,
  fontType,
  styleType
}: AddressSearchItemMobileProps): JSX.Element => {
  return (
    <div
      className={cn(styles.container, className, {
        [styles.xs]: sizeType === 'xs',
        [styles.sm]: sizeType === 'sm',
        [styles.md]: sizeType === 'md',
        [styles.lg]: sizeType === 'lg',
        [styles.xl]: sizeType === 'xl',
        [styles.fontXs]: fontType === 'xs',
        [styles.fontSm]: fontType === 'sm',
        [styles.fontMd]: fontType === 'md',
        [styles.fontLg]: fontType === 'lg',
        [styles.fontXl]: fontType === 'xl',
        [styles.primary]: styleType === 'primary',
        [styles.secondary]: styleType === 'secondary',
        [styles.transparent]: styleType === 'transparent',
        [styles.inverse]: styleType === 'inverse',
        [styles.danger]: styleType === 'danger'
      })}
      onClick={onClick}
    >
      <span className={styles.address}>{address}</span>
      <div className={styles.count}>
        <LogoUser className={styles.icon} />
        <span>{count}</span>
      </div>
    </div>
  )
}
